import ctl from '@netlify/classnames-template-literals'

const keyword = ctl('text-fuchsia-400')
const langConstants = ctl('text-purple-400')

export const codeStyleMap = {
	'string': ctl('text-green-300'),
	'property': ctl('text-purple-300'),
	'operator': ctl('text-red-500'),
	'punctuation': ctl('text-grey-600'),
	'comment': ctl('text-grey-600'),
	'plain': ctl('text-purple-400'),
	'regex': ctl('text-green-400'),
	keyword,
	'function': keyword,
	'builtin': langConstants,
	'number': langConstants,
	'class-name': ctl('text-red-400'),
	'attr-name': ctl('text-aqua-400'),
} as const
